import {useMutation, useQuery, useQueryClient} from "react-query";
import {createProject, deleteProject, fetchProject, fetchProjectsOfUser, updateProject} from "../api/projectApi";


export function useProject(token, id){
    return useQuery({
        queryKey: ['project', id],
        queryFn: () => fetchProject(token, id),
        enabled : !!token && !!id
    })
}

export function useProjects(token){
    return useQuery({
        queryKey: ['projects'],
        queryFn: () => fetchProjectsOfUser(token),
        enabled : !!token
    })
}

export function useCreateProject(token){
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (projectData) => createProject(token, projectData),
        onSuccess: () => {
            queryClient.invalidateQueries(['projects'])
        }
    })
}

export function useUpdateProject(token, id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (projectData) => updateProject(token, id, projectData),
        onSuccess: () => {
            queryClient.invalidateQueries(['project', id]);
            queryClient.invalidateQueries(['projects']);
        }
    });
}

export function useDeleteProject(token) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (projectId) => deleteProject(token, projectId),
        onSuccess: () => {
            queryClient.invalidateQueries(['projects']);
        }
    });
}
